import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from '../environment/environment.service';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LandingPageService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  private resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/email';
  }

  checkEmailAdressVerification(guid: string, systemId?: string): Promise<HttpResponse<null | string>> {
    return lastValueFrom(
      this.http.post<null | string>(this.resourceUrl + '/verification?guid=' + guid + '&systemId=' + systemId, {}, { observe: 'response' }),
    );
  }
}
